import { Directive, Input, OnDestroy, Optional, Self } from '@angular/core';
import { FormControlDirective, FormControlName } from '@angular/forms/';
import { Subject, Subscription } from 'rxjs';

@Directive({
  selector: '[brdKeepDisabled]'
})
export class KeepDisabledDirective implements OnDestroy {
  private _keepDisabled: boolean = false;
  private destroyed$: Subject<boolean> = new Subject<boolean>();
  private _subscritpion: Subscription;

  @Input('brdKeepDisabled')
  set keepDisabled(keepDisabled: boolean) {
    this._keepDisabled = keepDisabled;
    setTimeout(() => {
      this.updateDisabled();
    }, 50);
  }

  constructor(@Optional() @Self() private _formControlDirective?: FormControlDirective,
              @Optional() @Self() private _formControlNameDirective?: FormControlName) {
    if (!_formControlDirective && !_formControlNameDirective) {
      throw new Error("Either FormControl or FormControlName directive is required.");
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
  }

  private updateDisabled() {
    if (this._keepDisabled) {
      var control = this._formControlDirective == null ? this._formControlNameDirective.control : this._formControlDirective.control;
      var statusChanges = this._formControlDirective == null ? this._formControlNameDirective.statusChanges : this._formControlDirective.statusChanges;
      control.disable();
      this._subscritpion = statusChanges
        .takeUntil(this.destroyed$)
        .subscribe(() => {
          if (!control.disabled) {
            control.disable();
          }
        });
    } else if (this._subscritpion) {
      this._subscritpion.unsubscribe();
      this._subscritpion = undefined;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/directives/keep-disabled.directive.ts